import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { setLenis } from "@/lib/smooth";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { HowItWorks } from "@/components/HowItWorks";
import { WhyUs } from "@/components/WhyUs";
import { Testimonials } from "@/components/Testimonials";
import { Calculator } from "@/components/Calculator";
import { Pricing } from "@/components/Pricing";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";
import { BookingModal } from "@/components/BookingModal";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { Courses } from "@/components/Courses";
import { Shop } from "@/components/Shop";

function Landing() {
    const [bookingOpen, setBookingOpen] = useState(false);
    const openBooking = () => setBookingOpen(true);

    useEffect(() => {
        const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (reduced) return;
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        setLenis(lenis);
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            setLenis(null);
        };
    }, []);

    return (
        <div className="grain">
            <Header onBook={openBooking} />
            <main>
                <Hero onBook={openBooking} />
                <Marquee items={["Your Ink", "Your Numbers", "Your Story", "Decode Your Destiny"]} />
                <About />
                <Services onBook={openBooking} />
                <HowItWorks />
                <WhyUs />
                <Testimonials />
                <Courses />
                <Shop />
                <Marquee items={["Handwriting Analysis", "Signature Analysis", "Numerology", "Name Correction", "Crystal Remedies", "Logo Analysis", "Relationship Insights", "Namekaran", "Graphology Course"]} />
                <Calculator onBook={openBooking} />
                <Pricing onBook={openBooking} />
                <FinalCTA onBook={openBooking} />
            </main>
            <Footer onBook={openBooking} />
            <BookingModal open={bookingOpen} onClose={() => setBookingOpen(false)} />
        </div>
    );
}

function App() {
    return (
        <div className="App">
            <Toaster theme="dark" position="bottom-right" />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<AdminDashboard />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
